import React, { useState } from "react";
import "./DefinicoesPopup.css";
import {
  reauthenticateWithCredential,
  EmailAuthProvider,
  updatePassword,
  deleteUser
} from "firebase/auth";
import { auth } from "../firebase"; // ajusta o caminho conforme tua estrutura

function DefinicoesPopup({ email, onClose }) {
  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [repetirSenha, setRepetirSenha] = useState("");
  const [senhaParaDeletar, setSenhaParaDeletar] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSalvar() {
    if (!senhaAtual || !novaSenha || novaSenha !== repetirSenha) {
      alert("Verifica os campos: as senhas devem coincidir.");
      return;
    }

    try {
      setLoading(true);
      const user = auth.currentUser;
      const credencial = EmailAuthProvider.credential(user.email, senhaAtual);
      await reauthenticateWithCredential(user, credencial);
      await updatePassword(user, novaSenha);
      alert("Senha atualizada com sucesso!");
      setSenhaAtual("");
      setNovaSenha("");
      setRepetirSenha("");
    } catch (erro) {
      console.error("Erro ao atualizar senha:", erro);
      alert("Erro ao atualizar senha. Verifica se a senha atual está correta.");
    } finally {
      setLoading(false);
    }
  }

  async function handleDeletarConta() {
    const confirmar = window.confirm("Tem a certeza que deseja deletar a sua conta? Esta ação é irreversível.");
    if (!confirmar) return;

    if (!senhaParaDeletar) {
      alert("Por favor, insere a tua senha para confirmar.");
      return;
    }

    try {
      setLoading(true);
      const user = auth.currentUser;
      const cred = EmailAuthProvider.credential(user.email, senhaParaDeletar);
      await reauthenticateWithCredential(user, cred);

      await deleteUser(user);
      alert("Conta deletada com sucesso.");
      window.location.href = "/";
    } catch (erro) {
      console.error("Erro ao deletar conta:", erro);
      if (erro.code === "auth/wrong-password") {
        alert("Senha incorreta. Tenta novamente.");
      } else {
        alert("Erro ao deletar conta. Faz login novamente e tenta outra vez.");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="popup-definicoes-overlay">
        <div className="quadro">
        <button className="popup-fechar2" onClick={onClose} title="Fechar">
          ×
        </button>
      <div className="popup-definicoes">
        
        <h2 className="definacoes">DEFINIÇÕES</h2>

        <div className="email-box">
          <label>Email registrado:</label>
          <div className="email-mostrado">{email}</div>
          <small>Não pode ser alterado.</small>
        </div>

        <h4 className="subtitulo">ATUALIZAR SENHA</h4>

        <label className="definacoes2">SENHA ATUAL</label>
        <input
          type="password"
          value={senhaAtual}
          onChange={(e) => setSenhaAtual(e.target.value)}
          placeholder="Necessária para atualizar a senha atual"
        />

        <label className="definacoes2">NOVA SENHA</label>
        <input
          type="password"
          value={novaSenha}
          onChange={(e) => setNovaSenha(e.target.value)}
        />

        <label className="definacoes2">REPETIR SENHA</label>
        <input
          type="password"
          value={repetirSenha}
          onChange={(e) => setRepetirSenha(e.target.value)}
        />

        <button className="btn-salvar" onClick={handleSalvar} disabled={loading}>
          {loading ? "Salvando..." : "SALVAR"}
        </button>

        <div className="box-deletar">
          <strong>QUER DELETAR A SUA CONTA?</strong>
          <p>
            Lembre-se que essa ação não pode ser desfeita
            <br />
            e nenhum registro poderá ser restabelecido.
          </p>

          <label>CONFIRMAÇÃO DE SENHA</label>
          <input
            type="password"
            value={senhaParaDeletar}
            onChange={(e) => setSenhaParaDeletar(e.target.value)}
            placeholder="Coloque a sua senha para confirmar"
          />

          <button className="btn-deletar" onClick={handleDeletarConta} disabled={loading}>
            {loading ? "A apagar..." : "QUERO DELETAR"}
          </button>
        </div>
      </div>
      </div>
    </div>
  );
}

export default DefinicoesPopup;